import createActionType from "@/redux/utils/createActionType";

export const MODULE = "sales-order/sort";

export const SET_SORT = createActionType(MODULE, "setSort");

export const RESET = createActionType(MODULE, "reset");
